import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { PersonalInfoComponentView } from '../PersonalInfoComponentView';
import { WprDI_Object } from '../../../wpr-framework/view/di/WprDI_Object';

/**
 * 個人情報登録：住所検索モード
 */
export class PersonalInfoAddressMode extends WprBaseViewModeInfo<PersonalInfoComponentView> {
	// DI情報  ------------------------------------------------------------------
	@WprDI_Object
	private m_HttpStatus: boolean = false;
	// --------------------------------------------------------------------------
	
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('personalInfoAddressMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('住所検索可能');
		list.push('住所検索不可');
	}
	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('prefecture', { 
			readOnly: 		[ { mode: '住所検索不可', value: false }, 				{ mode: '住所検索可能', value: true }]});
		this.addControl('address1', { 
			readOnly: 		[ { mode: '住所検索不可', value: false }, 				{ mode: '住所検索可能', value: true }],
			placeholder: 	[ { mode: '住所検索不可', value: '※入力してください。'}, { mode: '住所検索可能', value: '※郵便番号より自動的に設定します。'}]
		});
	}
	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		if (this.m_HttpStatus)
			return '住所検索可能';
		else
			return '住所検索不可';
	}
	// --------------------------------------------------------------------------
}
